// extracted by mini-css-extract-plugin
export default {"container":"Note_container__dVy9a","buttons":"Note_buttons__0qB5d","btn":"Note_btn__J3Vpo","saveBtn":"Note_saveBtn__d3+MK","date":"Note_date__ojDrB","note":"Note_note__tRG2+"};